// Version : 1.0.0
// Author : AGALYA

import { API_URL } from '../../../const';

/** ***************** FETCH ADVANCE MEMBER LIST START *********************** */
export const fetchAdvanceMemberListService = async (Credentils: any) => {
	const data = {
		AddMemberToken: Credentils,
	};
	const response = await fetch(`${API_URL}getAdvanceMemeberList`, {
		method: 'POST',
		body: JSON.stringify(data),
	});
	return response.json();
};
/** ***************** FETCH ADVANCE MEMBER LIST END *********************** */
